import { render, staticRenderFns } from "./footer-primary.vue?vue&type=template&id=2ba1daa2&scoped=true&"
import script from "./footer-primary.vue?vue&type=script&lang=js&"
export * from "./footer-primary.vue?vue&type=script&lang=js&"
import style0 from "./footer-primary.vue?vue&type=style&index=0&id=2ba1daa2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba1daa2",
  null
  
)

/* custom blocks */
import block0 from "./footer-primary.vue?vue&type=custom&index=0&blockType=body"
if (typeof block0 === 'function') block0(component)

export default component.exports